// Generated by Ktorfit
@file:Suppress("warnings")

package kpt.core.network.worldbank.api

import de.jensklingenberg.ktorfit.Ktorfit
import de.jensklingenberg.ktorfit.`internal`.ClassProvider
import de.jensklingenberg.ktorfit.`internal`.InternalKtorfitApi
import de.jensklingenberg.ktorfit.`internal`.KtorfitConverterHelper
import io.ktor.client.HttpClient
import io.ktor.client.request.HttpRequestBuilder
import io.ktor.client.request.parameter
import io.ktor.http.HttpMethod
import io.ktor.http.encodeURLPath
import io.ktor.http.takeFrom
import io.ktor.util.reflect.typeInfo
import kotlin.Int
import kotlin.OptIn
import kotlin.String
import kotlin.Suppress
import kpt.core.base.network.`annotation`.ApiBinding
import kpt.core.network.worldbank.dto.WorldBankResponseDto

@OptIn(InternalKtorfitApi::class)
@ApiBinding(accessPoint = "worldbank")
public class _WorldBankApiImpl(
  private val _baseUrl: String,
  private val _httpClient: HttpClient,
  private val _helper: KtorfitConverterHelper,
) : WorldBankApi {
  override suspend fun indicator(
    countryCode: String,
    indicator: String,
    format: String,
    perPage: Int,
    dateRange: String,
  ): WorldBankResponseDto {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_baseUrl + "v2/country/${"$countryCode".encodeURLPath()}/indicator/${"$indicator".encodeURLPath()}")
        format?.let{ parameter("format", "$it") }
        perPage?.let{ parameter("per_page", "$it") }
        dateRange?.let{ parameter("date", "$it") }
        } 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<WorldBankResponseDto>(),)!! 
  }
}

public class _WorldBankApiProvider : ClassProvider<WorldBankApi> {
  override fun create(_ktorfit: Ktorfit): WorldBankApi = _WorldBankApiImpl(_ktorfit.baseUrl, _ktorfit.httpClient, KtorfitConverterHelper(_ktorfit))
}

public fun Ktorfit.createWorldBankApi(): WorldBankApi = _WorldBankApiImpl(this.baseUrl, this.httpClient, KtorfitConverterHelper(this))
